interface IScreenInfo {
    width: number;
    height: number;
    pixelRatio: number;
    colorDepth: number;
    isTouchEnabled: boolean;
}

interface IExtendedNavigator extends Navigator {
    MaxTouchPoints: number;
}

export enum DeviceType {
    Desktop = "Desktop",
    Mobile = "Mobile",
    Tablet = "Tablet",
}

export enum Browser {
    IE = "MSIE",
    CHROME = "Chrome",

    FIREFOX = "Firefox",
    SAFARI = "Safari",
    EDGE = "Edge",
    ANHEIM = "Anheim",

    OPERA = "Opera",

    UNKNOWN = "Unknown",
}

export enum OperatingSystem {
    WINDOWS = "Windows",
    MACOSX = "Mac OS X",
    IOS = "iOS",
    ANDROID = "Android",
    LINUX = "Linux",
    UNKNOWN = "Unknown",
}

const agent =  window.navigator.userAgent;

export const getBrowserName = () => {
    if (agent.indexOf("Chrome") > -1 && agent.indexOf("Edg") === -1) {
        return Browser.CHROME;
    }

    if (agent.indexOf("Edge") > -1) {
        return Browser.EDGE;
    }

    if (agent.indexOf("Edg") > -1) {
        return Browser.ANHEIM;
    }

    if (agent.indexOf("Safari") > -1) {
        return Browser.SAFARI;
    }

    if (agent.indexOf(Browser.FIREFOX) > -1) {
        return Browser.FIREFOX;
    }

    if (agent.indexOf("OPR") > -1) {
        return Browser.OPERA;
    }

    if (agent.indexOf("Trident") > -1) {
        return Browser.IE;
    }

    return "Unknown";
};

export const getOsName = () => {
    const win = /(windows|win32)/i;
    const osx = /(macintosh|mac os x)/i;
    const ios = /(iPad|iPhone|iPod)(?=.*like Mac OS X)/i;
    // tslint:disable-next-line: max-line-length
    const linux = /(linux|joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|cros)/i;
    const android = /android/i;

    if (agent.match(ios)) {
        return OperatingSystem.IOS;
    }
    if (agent.match(android)) {
        return OperatingSystem.ANDROID;
    }
    if (agent.match(linux)) {
        return OperatingSystem.LINUX;
    }
    if (agent.match(osx)) {
        return OperatingSystem.MACOSX;
    }
    if (agent.match(win)) {
        return OperatingSystem.WINDOWS;
    }

    return OperatingSystem.UNKNOWN;

};

export const getScreenInfo = () => {

    const navigator = window.navigator as IExtendedNavigator;

    return {
        colorDepth: window.screen.colorDepth || 0,
        height: window.screen.height || 0,
        isTouchEnabled: Object.prototype.hasOwnProperty.call(window, "ontouchstart") || navigator.MaxTouchPoints > 0,
        pixelRatio: window.devicePixelRatio || 0,
        width: window.screen.width || 0,
    } as IScreenInfo;
};

export const getDeviceType = () => {
        // tslint:disable-next-line:max-line-length
        const mobile = /(android|ipod|\w*?mobile\w*?|\w*?phone\w*?)/i;
        const tablet = /tablet|ipad/i;

        if (window.navigator.userAgent.match(mobile)) {
            return DeviceType.Mobile;
        }
        if (window.navigator.userAgent.match(tablet)) {
            return DeviceType.Tablet;
        }
        return DeviceType.Desktop;
};
